import { render, staticRenderFns } from "./TotalSubmitter.vue?vue&type=template&id=077cecf7"
import script from "./TotalSubmitter.vue?vue&type=script&lang=js"
export * from "./TotalSubmitter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports